import { Box, Chip, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { getMaintenanceTask } from "routes/component-library/controller/maintenance-library"
import { parseComponentTokenId } from "authoring/routes/macro/lib/parse-component-token-id"

const ELEMENT_LABELS = {
    heading: "Heading",
    classification: "Classification",
    frequencyCode: "Frequency",
    skillSet: "Skill Set",
    actionsHtml: "Actions",
    notesHtml: "Notes",
    authorsNotesHtml: "Author Notes",
    componentInstructionsHtml: "Component Instructions",
    internalNotes: "Internal Notes",
    relationships: "Relationships",
    compliance: "Compliance",
    tags: "Tags",
    originalText: "Original Text",
}

export function ComponentTokenInfo({ tokenId, isBroken }) {
    const parsed = parseComponentTokenId(tokenId)
    if (!parsed) return null
    const elementLabel = ELEMENT_LABELS[parsed.element] || parsed.element

    const task = getMaintenanceTask.useResults(parsed.taskId)
    const componentInstructions = task?.componentInstructionsHtml

    return (
        <Stack spacing={0.5} sx={{ px: 0.5 }}>
            <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
                <Chip
                    label="Component"
                    size="small"
                    color={isBroken ? "error" : "secondary"}
                    variant="outlined"
                    sx={{ height: 22, fontSize: "0.7rem" }}
                />
                <Chip label={elementLabel} size="small" variant="outlined" sx={{ height: 22, fontSize: "0.7rem" }} />
            </Stack>
            <Typography variant="caption" color="text.disabled" sx={{ fontFamily: "monospace", fontSize: "0.65rem" }}>
                {tokenId}
            </Typography>
            <If value={componentInstructions}>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                    Component Instructions
                </Typography>
                <Box
                    className="styled-bullets"
                    sx={{
                        typography: "caption",
                        px: 0.75,
                        py: 0.5,
                        borderRadius: 1,
                        bgcolor: "action.hover",
                        border: "1px solid",
                        borderColor: "divider",
                        wordBreak: "break-word",
                        "& p": { mt: 0, mb: 0.5 },
                        "& p:last-of-type": { mb: 0 },
                    }}
                    dangerouslySetInnerHTML={{ __html: componentInstructions }}
                />
            </If>
        </Stack>
    )
}
